const CHUNK_RELOAD_KEY = 'tcards:chunk-reload';

/** True when a dynamic import failed because a hashed chunk is missing (stale cache after deploy). */
export function isChunkLoadError(error: unknown): boolean {
  const msg =
    (error instanceof Error ? error.message : String(error ?? '')) +
    (error && typeof error === 'object' && 'message' in error
      ? String((error as { message?: unknown }).message ?? '')
      : '');
  return (
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /Loading chunk \d+ failed/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  );
}

/** Reload once per session so users recover after deploy without an infinite loop. */
export function reloadForStaleChunks(reason: string): boolean {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return false;
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return false;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  console.warn('[chunk-reload]', reason);
  window.location.reload();
  return true;
}

export function installChunkReloadHandlers(): void {
  if (typeof window === 'undefined') return;

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadForStaleChunks('vite:preloadError');
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      event.preventDefault();
      reloadForStaleChunks('unhandledrejection');
    }
  });
}
